import { render, staticRenderFns } from "./SettingExpress.vue?vue&type=template&id=b99944b2&"
import script from "./SettingExpress.vue?vue&type=script&lang=js&"
export * from "./SettingExpress.vue?vue&type=script&lang=js&"
import style0 from "./SettingExpress.vue?vue&type=style&index=0&id=b99944b2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports